import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';

import { DocumentType } from '../../../models/document-type';

import { DocumentTypeService } from '../../../services/documents/document-type.service';

@Component({
  selector: 'app-document-type-list',
  templateUrl: './document-type-list.component.html',
  styleUrls: ['./document-type-list.component.scss'],
})
export class DocumentTypeListComponent implements OnInit, OnChanges {
  @Input() documentTypes: Array<any> = [];

  @Input() indent: boolean = true;

  @Input() listType: boolean = true;

  @Input() loadChildren: boolean = true;

  @Input() selectedDocumentTypeId: number;

  @Input() updatedDocumentTypeNumber: number;

  @Input() showCheckbox: boolean = false;

  @Input() showExpandChildren: boolean = true;

  @Output() selectedDocumentType: EventEmitter<DocumentType> = new EventEmitter();

  constructor(private documentTypeService: DocumentTypeService) {}

  // Component lifecycle events
  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.updatedDocumentTypeNumber && this.documentTypes) {
      for (let documentType of this.documentTypes)
        if (documentType.id == this.selectedDocumentTypeId)
          this.documentTypeService.get(documentType.id).then((response_json) => {
            documentType.prefix = response_json.document_type.prefix;
            documentType.name = response_json.document_type.name;
            documentType.prefix_letter = response_json.document_type.prefix_letter;
            documentType.description = response_json.document_type.description;
            documentType.is_active = response_json.document_type.is_active;
            documentType.children = response_json.document_type.children;
          });
    }
  }

  // Component methods
  toggleDocumentType(documentType: DocumentType) {
    documentType.expanded = !documentType.expanded;
    if (this.loadChildren && documentType.expanded) {
      documentType.loading = true;
      this.documentTypeService
        .getChildren(documentType.id)
        .then((response_json) => {
          documentType.loading = false;
          documentType.children = response_json.children;
        })
        .catch(() => {
          documentType.loading = false;
        });
    }
  }

  selectDocumentType(documentType: DocumentType) {
    this.selectedDocumentType.emit(documentType);
  }
}
